var boostPFSFilterConfig = {
  general: {
    limit: document.querySelector('#collection-ad-template') ? 22 : 24,
    filterTreeMobileStyle: 'style3',
    separateRefineByFromFilter: true,
    requestInstantly: true,
    keepScrollState: false,
    enableKeepScrollbackPosition: false
  }
};

(function() {
  var firstVariant = {};
  var productInfo = {
    'type': '', // standard, top or bottom
    'groupHandle': '' // group collection handle based off tags
  };
  var metafields = {
    'title': '',
    'related_top_product': '',
    'related_bottom_product': ''
  };

  BoostPFS.inject(this);

  /**
   * Prepare Shopify Data
   */
  function prepareShopifyData(data) {
    // Get First Variant (selected_or_first_available_variant)
    firstVariant = data['variants'][0];
    if (Utils.getParam('variant') !== null && Utils.getParam('variant') != '') {
      var paramVariant = data.variants.filter(function(e) {
        return e.id == Utils.getParam('variant');
      });
      if (typeof paramVariant[0] !== 'undefined') firstVariant = paramVariant[0];
    } else {
      for (var i = 0; i < data['variants'].length; i++) {
        if (data['variants'][i].available) {
          firstVariant = data['variants'][i];
          break;
        }
      }
    }

    if (data.hasOwnProperty('metafields')) {
      var namespace = 'accentuate';
      metafields.title = Utils.getProductMetafield(data, namespace, 'title');
      metafields.related_top_product = Utils.getProductMetafield(data, namespace, 'related_top_products');
      metafields.related_bottom_product = Utils.getProductMetafield(data, namespace, 'related_bottom_products');

      if (metafields.related_bottom_product != null) {
        productInfo.type = 'top';
      } else if (metafields.related_top_product != null) {
        productInfo.type = 'bottom';
      } else {
        productInfo.type = 'standard';
      }
    }

    // remove this line, this is just for the demo
    // if (data.title.includes('Top')) {
    // productInfo.type = 'top';
    // }

    // group collection handle
    productInfo.groupHandle = '';
    data.tags.filter(tag => {
      if (tag.indexOf('group-') !== -1) {
        productInfo.groupHandle = tag;
      }
    });

    return data;
  }


  /**
   * Product Tile
   */
  ProductGridItem.prototype.compileTemplate = function(data) {
    if (!data) data = this.data;
    data = prepareShopifyData(data);
    //console.log(productInfo);
    //console.log(metafields);
    // console.log(data, 'data')

    // Get Template
    var itemHtml = boostPFSTemplate.productGridItemHtml;
    // Add Images
    itemHtml = buildImages(data, itemHtml);
    // Add Wishlist Icon
    itemHtml = itemHtml.replace(/{{iconWishlist}}/g, buildWishlistIcon(data));
    // Add Badge
    itemHtml = itemHtml.replace(/{{productBadge}}/g, buildBadge(data));
    // Add Group Collection Handle
    itemHtml = itemHtml.replace(/{{groupCollectionHandle}}/, productInfo.groupHandle);
    // Add Price
    itemHtml = itemHtml.replace(/{{productPrice}}/g, Utils.formatMoney(data.price_min));
    // Compare at Price
    if (data.compare_at_price_min && data.compare_at_price_min > 0 && data.compare_at_price_min != data.price_min) {
      itemHtml = itemHtml.replace(/{{productComparePrice}}/g, `<s aria-label="Was ${Utils.stripHtml(Utils.formatMoney(data.compare_at_price_min))}" class="product-tile__price-compare">${Utils.formatMoney(data.compare_at_price_min)}</s>`);
      itemHtml = itemHtml.replace(/{{classOnSale}}/g, ' highlight');
    } else {
      itemHtml = itemHtml.replace(/{{productComparePrice}}/g, '');
      itemHtml = itemHtml.replace(/{{classOnSale}}/g, '');
    }
    // carousel images
    const carouselImages = data.images_info.reduce((slides, {src, alt}, index) => {
      if((data.product_type == "Swim - Bikini Tops" || data.product_type == "Swim - Bikini Bottoms" || data.product_type == "Clothing - Tops" || data.product_type == "Clothing - Shorts" || data.product_type == "Clothing - Pants" || data.product_type == "Clothing - Skirts" ) && index == 0){
        return slides
      }
        return slides += `<div class="swiper-slide ${alt?.includes("vimeo") ? "cm-video" : ""}"><a href="${Utils.buildProductItemUrl(data)}">${!alt?.includes("vimeo") ? `<img loading="lazy" src="${src}" alt="${alt}" data-id="${data.id}">` : `<iframe
          width="100%"
          height="auto"
          frameborder="0"
          allow="autoplay; fullscreen; picture-in-picture"
          allowfullscreen
          loading="lazy"
          src="https://player.vimeo.com/video/${alt?.split("/").slice(-1)[0]}?background=1&autoplay=1&muted=1&loop=1&autopause=0&controls=0"
        ></iframe>`}</a></div>`
    },"")
    itemHtml = itemHtml.replace(/{{carousel_imgs}}/g, carouselImages);

    setTimeout(_ => {
      window[`swiperCM_${data.id}`] = new Swiper2(`.cm-sw-${data.id}`, {
          loop: true,
          navigation: {
            nextEl: `.cm-next-${data.id}`,
            prevEl: `.cm-prev-${data.id}`,
          },
          scrollbar: {
            el: `.cm-scroll-${data.id}`,
          },
      });
    }, 100)

    setTimeout(() => {
      window[`swiperCM_${data.id}`].update();
    }, 250);

    // PLP Discount Code
    var discountCodeConfig = data.tags.includes('sale') ? window.SaleDiscountCode : window.SitewideDiscountCode
    if (typeof discountCodeConfig !== 'undefined' && discountCodeConfig.enabled && discountCodeConfig.code !== '') {
      itemHtml = itemHtml.replace(/{{productDiscountCode}}/g, buildDiscountCode(data, discountCodeConfig))
    } else {
      itemHtml = itemHtml.replace(/{{productDiscountCode}}/g, '')
    }

    // Add main attribute (Always put at the end of this function)
    itemHtml = itemHtml.replace(/{{productType}}/g, productInfo.type);
    itemHtml = itemHtml.replace(/{{productID}}/g, data.id);
    itemHtml = itemHtml.replace(/{{productHandle}}/g, data.handle);
    itemHtml = itemHtml.replace(/{{variantID}}/g, firstVariant.id);
    itemHtml = itemHtml.replace(/{{productTitle}}/g, buildTitle(data));
    itemHtml = itemHtml.replace(/{{productURL}}/g, Utils.buildProductItemUrl(data));
    itemHtml = itemHtml.replace(/{{productFullURL}}/g, boostPFSThemeConfig.custom.shop_url + Utils.buildProductItemUrl(data));

    // Add to Bag PLP
    itemHtml = itemHtml.replace(/{{addToBag}}/g, buildAddToBag(data));

    return itemHtml;
  };

  //Build Add to Bag PLP
function buildAddToBag(data) {

  // Check if the product is a pre-order item
  if (window.location.href.includes("pre-order")) {
    return `<div style="display: none;"></div>`;
  }

  let variantHtml = '';

  if (data.variants.length > 1) {
    let sizeButtons = '';
    let hasAvailableVariant = false;

    data.variants.forEach(function(variant) {
      let variantTitle = variant.title;
      let variantId = variant.id;

      if (variant.available) {
        hasAvailableVariant = true;
        sizeButtons += `
          <div class="product-tile__addToBag-button-sizes">
            <button data-variantAddToBag="${variantId}">
              ${variantTitle}
            </button>
          </div>
        `;
      } else {
        sizeButtons += `
          <div class="product-tile__addToBag-button-sizes --outOfStockButtons">
            <button data-variantAddToBag="${variantId}" disabled>
              ${variantTitle}
            </button>
          </div>
        `;
      }
    });

    if (hasAvailableVariant) {
      variantHtml = `
        <div class="product-tile__addToBag-container">
          <button class="product-tile__addToBag-button-add">
            ADD TO BAG
          </button>

          <button class="product-tile__addToBag-button-add --mobile">
            <p>ADD</p><span class="product-tile__addToBag-button-mobile"><img src="https://cdn.shopify.com/s/files/1/2141/1439/files/bagVix.png?v=1730146491" width="18" height="18" alt="image of bag"><img src="https://cdn.shopify.com/s/files/1/2141/1439/files/arrowDown.png?v=1730146558" width="12" height="8" alt="Arrow Down"></span>
          </button>
          <div class="product-tile__addToBag-buttons" data-product-tile-sizes>
            ${sizeButtons}
          </div>
        </div>
      `;
    } else {
      variantHtml = `
        <div class="product-tile__addToBag-container">
          <button class="product-tile__addToBag-outOfStock"><strong>OUT OF STOCK</strong></button>

          <button class="product-tile__addToBag-button-add --mobile">
            <p>ADD</p><span class="product-tile__addToBag-button-mobile"><img src="https://cdn.shopify.com/s/files/1/2141/1439/files/bagVix.png?v=1730146491" width="18" height="18" alt="image of bag"><img src="https://cdn.shopify.com/s/files/1/2141/1439/files/arrowDown.png?v=1730146558" width="12" height="8" alt="Arrow Down"></span>
          </button>
          <div class="product-tile__addToBag-buttons" data-product-tile-sizes>
          </div>
        </div>
      `;
    }
  } else {
    let variant = data.variants[0];
    let variantId = variant.id;

    if (variant.available) {
      variantHtml = `
        <button data-variantAddToBag="${variantId}" class="product-tile__ad-to-bag">
          ADD TO BAG
        </button>

        <button data-variantAddToBag="${variantId}" class="product-tile__ad-to-bag --mobile">
          <p>ADD</p><span class="product-tile__addToBag-button-mobile"><img src="https://cdn.shopify.com/s/files/1/2141/1439/files/bagVix.png?v=1730146491" width="18" height="18" alt="image of bag"></span>
        </button>
      `;
    } else {
      variantHtml = `
        <div class="product-tile__addToBag-container">
          <button class="product-tile__addToBag-outOfStock"><strong>OUT OF STOCK</strong></button>

          <button class="product-tile__addToBag-button-add --mobile">
            <p>ADD</p><span class="product-tile__addToBag-button-mobile"><img src="https://cdn.shopify.com/s/files/1/2141/1439/files/bagVix.png?v=1730146491" width="18" height="18" alt="image of bag"><img src="https://cdn.shopify.com/s/files/1/2141/1439/files/arrowDown.png?v=1730146558" width="12" height="8" alt="Arrow Down"></span>
          </button>
          <div class="product-tile__addToBag-buttons" data-product-tile-sizes>
          </div>
        </div>
      `;
    }
  }

  return variantHtml;
}

  function buildTitle(data) {
    var title = metafields.title;

    if (title === null || title === '') {
      var showColorNames = document.querySelector('[data-show-color-names]').dataset.showColorNames;
      if (showColorNames === 'false') {
        title = data.title.split('-');
        title = title[0];
        title = title.trim();
      } else {
        title = data.title
      }
    }

    return title;
  }

  // Product Tile Elements
  function buildImages(data, itemHtml) {
    var imageWidth = '430';
    var imageHeight = '560';
    var images = data.images_info;

    // var productType = data.product_type.toLowerCase().replace(/[^\w\u00C0-\u024f]+/g, "-").replace(/^-+|-+$/g, "");

    if (!images || images.length == 0) {
      images.push({
        src: boostPFSAppConfig.general.no_image_url,
        width: imageWidth,
        height: imageHeight
      });
    }

    var firstImageIndex = 0;
    if (boostPFSThemeConfig.custom.ignoreFirstImageTypes.includes(data.product_type)) {
      firstImageIndex = 1;
    }

    var firstImage = '';
    var firstImageAlt = data.title;
    var hoverImage = '';
    var hoverImageAlt = data.title;
    var firstImageSrc = Utils.optimizeImage(boostPFSAppConfig.general.no_image_url, `${imageWidth}x${imageHeight}`);;
    var hoverImageSrc = '';

    if (data.images_info[firstImageIndex] !== undefined) {
      firstImageSrc = Utils.optimizeImage(data.images_info[firstImageIndex].src, `${imageWidth}x${imageHeight}`);
      const alt = data.images_info[firstImageIndex].alt;
      if (alt && alt !== firstImageAlt) {
        firstImageAlt += ` - ${alt}`;
      }
    }

    if (data.images_info[firstImageIndex + 1] !== undefined) {
      hoverImageSrc = Utils.optimizeImage(data.images_info[firstImageIndex + 1].src, `${imageWidth}x${imageHeight}`);
      const alt = data.images_info[firstImageIndex + 1].alt;
      if (alt && alt !== hoverImageAlt) {
        hoverImageAlt += ` - ${alt}`;
      }
    }

    firstImage = `
      <img
        src="${firstImageSrc}"
        alt="${firstImageAlt}"
        class="product-tile__image"
        height="${imageHeight}"
        width="${imageWidth}"
        data-swap-image="image1"
      />
    `;

    if (hoverImageSrc !== '') {
      hoverImage = `
        <img
          src="${hoverImageSrc}"
          alt="${hoverImageAlt}"
          class="product-tile__image product-tile__image--hover"
          height="${imageHeight}"
          width="${imageWidth}"
          data-swap-image="image2"
          loading="lazy"
        />
      `;
    }

    itemHtml = itemHtml.replace(/{{productImages}}/g, `${firstImage}${hoverImage}`);
    itemHtml = itemHtml.replace(/{{productFirstImage}}/g, `${firstImageSrc}`);

    return itemHtml;
  }

  function buildWishlistIcon(data) {
    var wishlistIcon = `
    <svg role="img" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" width="21.605" height="19.81" viewBox="0 0 21.605 19.81">
      <g id="icons_Q2" data-name="icons Q2" transform="translate(0.625 0.625)">
        <path id="Path_243" data-name="Path 243" d="M16.8,4a5.98,5.98,0,0,0-4.626,3.007A5.98,5.98,0,0,0,7.551,4,5.551,5.551,0,0,0,3.619,5.665,5.505,5.505,0,0,0,2,9.6c0,1.9,1.249,3.516,2.313,4.719l7.54,8.049a.463.463,0,0,0,.648,0l7.54-8.049c1.064-1.2,2.313-2.822,2.313-4.719A5.6,5.6,0,0,0,16.8,4Z" transform="translate(-2 -4)" fill="none" stroke="#252525" stroke-width="1.25"/>
      </g>
    </svg>
    `;

    return wishlistIcon.trim();
  }

  function buildBadge(data) {
    var badgeHtml = '';
    var badgeText = false;
    var badgeTagPrefix = 'badge::';

    data.tags.filter(tag => {
      if (tag.indexOf(badgeTagPrefix) !== -1) {
        badgeText = tag.replace(badgeTagPrefix, '');
      }
    });

    if (badgeText) {
      badgeHtml = `
      <div class="product-badge">
        <p class="product-badge__text">${badgeText}</p>
      </div>`;
    }

    return badgeHtml;
  }

  function buildDiscountCode(data, discountCodeConfig) {
    var html = ''
    var finalsale = ''

    let code_price = 0
    if (discountCodeConfig.dollarOff && discountCodeConfig.dollarOff > 0) {
      code_price = data.price_min - discountCodeConfig.dollarOff
    } else {
      code_price = data.price_min * discountCodeConfig.newPercentDecimal
    }

    const is_final_sale = data.tags.includes('finalsale')
    if (is_final_sale) {
      finalsale = '<span class="product-tile__code-badge">FINAL SALE</span>'
    } else {
      finalsale = '<span class="product-tile__code-badge visually-hidden">FINAL SALE</span>'
    }

    html = `
      <div class="product-tile__code">
        <p class="product-tile__code-text">
          <span data-product-tile-code-price>${Utils.formatMoney(code_price)}</span> with code: <span>${discountCodeConfig.code}</span>
        </p>
        ${finalsale}
      </div>
    `.trim()

    return html;
  }


  /**
   * Product Tile Options - need to render this async
   */
  var $ad_template = $('#collection-ad-template');

  function productTileAd () {
    if( $ad_template.length && $('.product-tile-banner').length == 0 ){
      var $ad_el = $($ad_template.html());
      var ad_pos = parseInt( $ad_template.attr('data-position') );
      var $after_product = $('.collection .product-tile:nth-child('+ (ad_pos - 1) +')');

      var productCount = $('.collection .product-tile').length
      var isDesktop = window.matchMedia('(min-width: 1024px)').matches

      if( $after_product.length ){
        if (isDesktop && productCount > 4) {
          $after_product.after( $ad_el );
        } else if (!isDesktop) {
          $after_product.after( $ad_el );
        }
      }
    }
  }

  /** INFOCARDS AB TEST */

  var $ad_templatesABTEST = $('.collection-ad-templateABTest');

  function productTileAdABTEST() {
      if ($ad_templatesABTEST.length) {
          let productCount = $('.collection .product-tile').length;
          let insertEvery;
          let oldInfocard = $(".product-tile-banner");

        // Check if the URL is for the "sale" page
          if (!oldInfocard.length) {
              let isLargeScreen = window.matchMedia('(min-width: 1400px)').matches;
              let isMediumScreen = window.matchMedia('(min-width: 1000px)').matches && !isLargeScreen;
              let isSmallScreen = window.matchMedia('(max-width: 999px)').matches;

              if (isLargeScreen) {
                  insertEvery = 7;  // On large screens, insert every 7 products
              } else if (isMediumScreen || isSmallScreen) {
                  insertEvery = 5;  // On medium and small screens, insert every 5 products
              }
          } else {
            // Original logic for other pages
              let isLargeScreen = window.matchMedia('(min-width: 1400px)').matches;
              let isMediumScreen = window.matchMedia('(min-width: 1000px)').matches && !isLargeScreen;
              let isSmallScreen = window.matchMedia('(max-width: 999px)').matches;

              if (isLargeScreen) {
                  insertEvery = 8;  // On large screens, insert every 8 products
              } else if (isMediumScreen) {
                  insertEvery = 6;  // On medium screens, insert every 6 products
              } else if (isSmallScreen) {
                  insertEvery = 6;  // On small screens, insert every 6 products
              }
          }

          for (let i = 0; i < $ad_templatesABTEST.length; i++) {
              let $ad_template = $ad_templatesABTEST.eq(i);
              let positionIndex;

              if (!oldInfocard.length) {
                  positionIndex = (i + 1) * insertEvery - 1; // On "sale" page, insert according to 'insertEvery'
              } else {
                  // Original logic for other pages
                  if (i === 0) {
                      positionIndex = insertEvery - 1;
                  } else {
                      positionIndex = (i + 1) * insertEvery - (i + 1);
                  }
              }

              if (positionIndex >= productCount) {
                  break;
              }

              let $after_product = $('.collection .product-tile').eq(positionIndex);

              if ($after_product.length) {
                  let $ad_el = $($ad_template.html());
                  $after_product.after($ad_el);
              }
          }
      }
  }



  //Render productTileAd and AB TEST Infocard

  window.addEventListener('DOMContentLoaded', function() {
      productTileAd ()
      productTileAdABTEST();
  });

  ProductList.prototype.afterRender = function(data) {
    if (!data) data = this.data;

    this.buildExtrasProductListByAjax(data, 'boost-pfs-integration', function(results) {
        results.forEach(function(result) {
            var element = '';
            element = jQ('[data-product-id="' + result.id + '"]')
            if (element.find('.product-tile__price-wrap').length > 0) {
                element.find('.product-tile__price-wrap').append(result.prices.trim());
            }
        });
    });

    if (document.querySelector('[data-disable-swatches="true"]') === null) {
      window.ProductTile.fetchProductOptions();
    }

    window.ProductTile.fetchWishlistButtons();

    // Product Tile Ad
    productTileAd();

    window.wishlistButtonState()

    // ABTEST
    productTileAdABTEST();
  };

  /**
   * Pagination
   */
  ProductPaginationDefault.prototype.compileTemplate = function(totalProduct) {
    if (!totalProduct) totalProduct = this.totalProduct;
    // Get page info
    var currentPage = parseInt(Utils.stripHtml(Globals.queryParams.page));
    var totalPage = Math.ceil(totalProduct / Utils.stripHtml(Globals.queryParams.limit));
    if (!currentPage || isNaN(currentPage)) {
      currentPage = 1;
    }
    // If it has only one page, clear Pagination
    if (totalPage <= 1) {
      return '';
    }

    var paginationHtml = boostPFSTemplate.paginateHtml;
    // Build Previous
    var previousHtml = (currentPage > 1) ? boostPFSTemplate.previousActiveHtml : boostPFSTemplate.previousDisabledHtml;
    previousHtml = previousHtml.replace(/{{itemUrl}}/g, Utils.buildToolbarLink('page', currentPage, currentPage - 1));
    paginationHtml = paginationHtml.replace(/{{previous}}/g, previousHtml);
    // Build Next
    var nextHtml = (currentPage < totalPage) ? boostPFSTemplate.nextActiveHtml : boostPFSTemplate.nextDisabledHtml;
    nextHtml = nextHtml.replace(/{{itemUrl}}/g, Utils.buildToolbarLink('page', currentPage, currentPage + 1));
    paginationHtml = paginationHtml.replace(/{{next}}/g, nextHtml);
    // Create page items array
    var beforeCurrentPageArr = [];
    for (var iBefore = currentPage - 1; iBefore > currentPage - 3 && iBefore > 0; iBefore--) {
      beforeCurrentPageArr.unshift(iBefore);
    }
    if (currentPage - 4 > 0) {
      beforeCurrentPageArr.unshift('...');
    }
    if (currentPage - 4 >= 0) {
      beforeCurrentPageArr.unshift(1);
    }
    beforeCurrentPageArr.push(currentPage);
    var afterCurrentPageArr = [];
    for (var iAfter = currentPage + 1; iAfter < currentPage + 3 && iAfter <= totalPage; iAfter++) {
      afterCurrentPageArr.push(iAfter);
    }
    if (currentPage + 3 < totalPage) {
      afterCurrentPageArr.push('...');
    }
    if (currentPage + 3 <= totalPage) {
      afterCurrentPageArr.push(totalPage);
    }
    // Build page items
    var pageItemsHtml = '';
    var pageArr = beforeCurrentPageArr.concat(afterCurrentPageArr);
    for (var iPage = 0; iPage < pageArr.length; iPage++) {
      if (pageArr[iPage] == '...') {
        pageItemsHtml += boostPFSTemplate.pageItemRemainHtml;
      } else {
        pageItemsHtml += (pageArr[iPage] == currentPage) ? boostPFSTemplate.pageItemSelectedHtml : boostPFSTemplate.pageItemHtml;
      }
      pageItemsHtml = pageItemsHtml.replace(/{{itemTitle}}/g, pageArr[iPage]);
      pageItemsHtml = pageItemsHtml.replace(/{{itemUrl}}/g, Utils.buildToolbarLink('page', currentPage, pageArr[iPage]));
    }
    paginationHtml = paginationHtml.replace(/{{pageItems}}/g, pageItemsHtml);
    return paginationHtml;
  };

  ProductPaginationDefault.prototype._onClickEvent = function(event) {
    event.preventDefault();
    Globals.internalClick = true;

    // Get the new page value
    var url;
    try {
      url = new URL(jQ(event.currentTarget).attr('href'));
    } catch (e) {
      url = new URL('https://' + boostPFSConfig.shop.domain + jQ(event.currentTarget).attr('href'));
    }

    var pageValue = url && url.searchParams ? url.searchParams.get('page') : 1;
    if (!pageValue || isNaN(pageValue)) pageValue = 1;

    // Apply filter
    FilterApi.setParam('page', pageValue);
    FilterApi.applyFilter('page');

    const $pageSection = document.querySelector('section.collection') ? $('section.collection') : $('section.search-page')

    // Scroll to top of product list
    window.scrollTo({
      top: $pageSection.offset().top - $('[data-header]').outerHeight(),
      behavior: 'smooth'
    });
  }

  /**
   * Sorting Options
   */
  ProductSorting.prototype.compileTemplate = function () {
    if (boostPFSTemplate.hasOwnProperty('sortingHtml')) {
      var sortingArr = Utils.getSortingList();
      if (sortingArr) {
        // Build content
        var sortingItemsHtml = '';
        for (var k in sortingArr) {
          sortingItemsHtml += '<option value="' + k + '">' + sortingArr[k] + '</option>';
        }
        var html = boostPFSTemplate.sortingHtml.replace(/{{sortingItems}}/g, sortingItemsHtml);
        return html;
      }
    }
    return '';
  };


  /**
   * Move Filter Options
   */
  FilterTree.prototype.afterRender = function() {
    if(this.isMobileOnly) {
      return;
    }

    this.$element.find('.boost-pfs-filter-button.boost-pfs-filter-option-title-heading').each(function(){
      $(this).removeAttr('aria-label')
    });

    $('.boost-pfs-filter-button.boost-pfs-filter-clear').each(function(){
      const button = $(this)
      button.removeAttr('aria-label')
      button.append(`<span class="visually-hidden">Clear filter</span>`)
    });

    const handleVisible = (carousel) => {
      const slides = carousel.querySelectorAll('.swiper-slide')

      slides.forEach((slide) => {
        const buttons = slide.querySelectorAll('button')
        const links = slide.querySelectorAll('a')

        if (slide.classList.contains('swiper-slide-visible')) {
          slide.setAttribute('aria-hidden', 'false')
          buttons.forEach((button) => {
            button.setAttribute('tabindex', 0)
          })
          links.forEach((link) => {
            link.setAttribute('tabindex', 0)
          })
        } else {
          slide.setAttribute('aria-hidden', 'true')
          buttons.forEach((button) => {
            button.setAttribute('tabindex', -1)
          })
          links.forEach((link) => {
            link.setAttribute('tabindex', -1)
          })
        }
      })
    }

    // let's move the filter options to a new bar
    this.$element.find('.boost-pfs-filter-option-content').each(function(){
      const content = $(this)
      const carousel = content.find('.boost-pfs-filter-option-content-inner')[0]

      content.attr('tabindex', -1)
      content.find('.boost-pfs-filter-button *').attr('tabindex', -1)
      content.find('.boost-pfs-filter-option-item-list').addClass('swiper-wrapper')
      content.find('.boost-pfs-filter-option-item').addClass('swiper-slide')
      content.appendTo('.collection__filter-options')

      const trapFocus = () => {
        document.addEventListener('keydown', (e) => {
          const item = content.find('.swiper-slide-visible').length ? content.find('.swiper-slide-visible') : content.find('.boost-pfs-filter-option-item')
          const firstFocusableElement = item.first().find('button')[0]
          const lastFocusableElement = item.last().find('button')[0]
          const isTabPressed = e.key === 'Tab' || e.keyCode === 9

          if (!isTabPressed) {
            return
          }

          if (e.shiftKey) {
            if (document.activeElement === firstFocusableElement) {
              lastFocusableElement.focus()
              e.preventDefault()
            }
          } else {
            if (document.activeElement === lastFocusableElement) {
              firstFocusableElement.focus()
              e.preventDefault()
            }
          }
        })
      }

      new Swiper(carousel, {
        freeMode: true,
        keyboard: {
          enabled: true
        },
        loop: false,
        mousewheel: {
          forceToAxis: true
        },
        observer: true,
        on: {
          afterInit: () => {
            trapFocus()
          },
          activeIndexChange: () => {
            handleVisible(carousel)
            trapFocus()
          },
          init: (swpr) => {
            $('body').on('click', '.boost-pfs-filter-option-title', () => {
              setTimeout(() => {
                swpr.update()
                swpr.slideTo(0, 0) // Trigger resize for watchSlidesVisibility
              }, 10)
            })
          },
          resize: () => {
            handleVisible(carousel)
            trapFocus()
          }
        },
        roundLengths: true,
        slidesPerView: 'auto',
        slideToClickedSlide: true,
        spaceBetween: 14,
        watchSlidesVisibility: true
      })
    });

    document.addEventListener('keyup', (e) => {
      if (e.key === 'Enter') {
        const panel = $(`#${e.target.getAttribute('aria-controls')}`)
        if (panel.length && panel.is(':visible')) {
          panel.focus()
        }
      }

      if (e.key === 'Escape') {
        const content = e.target.closest('.boost-pfs-filter-option-content')
        if (content) {
          const button = document.querySelector(`[aria-controls="${content.id}"]`)
          if (button) {
            button.dispatchEvent(new Event('click', { bubbles: true }))
            button.focus()
          }
        }
      }
    })
  };

  /**
   * Results Count
   */
  Filter.prototype.afterRender = function(data) {
    if (!data) data = this.data;

    // results count
    $('[data-collection-results-count]').text(data.total_product);

    // clear all mobile drawer
    $('.collection__clear-all').html('');
    $('.collection__clear-all').append(this.filterTrees[0].clearAllButton.$element);

    // No results for search
    var searchPage = document.querySelector('[data-search-page]');
    if (document.querySelector('[data-search-page]') && data.total_product == 0) {
      searchPage.classList.add('no-results');
    }

    const drawer = document.querySelector('[data-mobile-filter-drawer]')
    if (drawer) {
      const focusableElements = drawer.querySelectorAll('button:not(.boost-pfs-filter-apply-all-button), [href], input, select, textarea, [tabindex]:not([tabindex="-1"])')
      const overlay = drawer.querySelector('.boost-pfs-filter-overlay')
      const isActive = document.querySelector('.boost-pfs-body-no-scroll')

      if (isActive) {
        if (overlay) {
          overlay.setAttribute('role', 'button')
          overlay.setAttribute('tabindex', 0)
        }

        focusableElements.forEach((element) => {
          element.setAttribute('tabindex', 0)
          element.setAttribute('aria-hidden', 'false')
        })
      } else {
        if (overlay) {
          overlay.removeAttribute('role')
          overlay.removeAttribute('tabindex')
        }

        focusableElements.forEach((element) => {
          element.setAttribute('tabindex', -1)
          element.setAttribute('aria-hidden', 'true')
        })
      }

      drawer.addEventListener('keydown', (e) => {
        const modal = document.querySelector('.boost-pfs-filter-tree-content')
        const firstFocusableElement = modal.querySelector('.boost-pfs-filter-close')
        const apply = modal.querySelector('.boost-pfs-filter-show-result')
        const clear = modal.querySelector('.boost-pfs-filter-clear-all')
        let lastFocusableElement = apply
        if (clear && $(clear).is(':visible')) {
          lastFocusableElement = clear
        }
        const isTabPressed = e.key === 'Tab' || e.keyCode === 9

        if (!isTabPressed) {
          return
        }

        if (e.shiftKey) {
          if (document.activeElement === firstFocusableElement) {
            lastFocusableElement.focus()
            e.preventDefault()
          }
        } else {
          if (document.activeElement === lastFocusableElement) {
            firstFocusableElement.focus()
            e.preventDefault()
          }
        }
      })

      if (document.querySelector('.boost-pfs-filter-tree-content')) {
        document.querySelector('.boost-pfs-filter-tree-content').removeAttribute('aria-live')
      }
    }
  };

  /**
   * Mobile Filter Drawer
   */

  // Mobile Filter Header
  FilterTree.prototype.getHeaderTemplate = function(){
    if(!this.isMobileOnly) {
      return '';
    }

    var html = `
      <div class="boost-pfs-filter-mobile-header">
        <span class="boost-pfs-filter-mobile-heading">
          <svg xmlns="http://www.w3.org/2000/svg" width="17.625" height="13" viewBox="0 0 17.625 13">
            <g transform="translate(-25.268 -692)">
              <rect id="Rectangle_902" data-name="Rectangle 902" width="17.625" height="1.3" transform="translate(25.268 694.65)" fill="#fff"/>
              <rect id="Rectangle_903" data-name="Rectangle 903" width="17.625" height="1.3" transform="translate(25.268 701.35)" fill="#fff"/>
              <g transform="translate(28 692)" fill="#252525" stroke="#fff" stroke-width="1.25">
                <circle cx="3" cy="3" r="3" stroke="none"/>
                <circle cx="3" cy="3" r="2.375" fill="none"/>
              </g>
              <g transform="translate(34 699)" fill="#252525" stroke="#fff" stroke-width="1.25">
                <circle cx="3" cy="3" r="3" stroke="none"/>
                <circle cx="3" cy="3" r="2.375" fill="none"/>
              </g>
            </g>
          </svg>
          Filters
        </span>
        <a href="javascript:;" class="{{class.closeFilterButton}}" aria-label="Close Filters" role="button">
          <svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" width="14px" height="14px" viewBox="0 0 14 14" xml:space="preserve">
            <polygon fill="#fff" points="14,1.056 12.944,0 7,5.944 1.056,0 0,1.056 5.944,7 0,12.944 1.056,14 7,8.056 12.944,14 14,12.944 8.057,7 "/>
          </svg>
        </a>
      </div>`;

    return html;
  };

  // Mobile Filter Footer
  FilterTree.prototype.getFooterTemplate = function(){
    if(!this.isMobileOnly) {
      return '';
    }

    var html = `
    <div class="boost-pfs-filter-mobile-footer">
      <button class="{{class.showResultFilterButton}}" type="button">Apply Filters</button>
      <div class="collection__clear-all"></div>
    </div>`;

    return html;
  };

  // toggle button
  FilterMobileButton.prototype.getTemplate = function (){
    var html = `
    <button type="button" aria-label="Filters" aria-haspopup="dialog">
      <svg xmlns="http://www.w3.org/2000/svg" width="17.625" height="13" viewBox="0 0 17.625 13">
        <g transform="translate(-25.268 -692)">
          <rect width="17.625" height="1.3" transform="translate(25.268 694.65)" fill="#252525"/>
          <rect width="17.625" height="1.3" transform="translate(25.268 701.35)" fill="#252525"/>
          <g transform="translate(28 692)" fill="#fff" stroke="#252525" stroke-width="1.25">
            <circle cx="3" cy="3" r="3" stroke="none"/>
            <circle cx="3" cy="3" r="2.375" fill="none"/>
          </g>
          <g transform="translate(34 699)" fill="#fff" stroke="#252525" stroke-width="1.25">
            <circle cx="3" cy="3" r="3" stroke="none"/>
            <circle cx="3" cy="3" r="2.375" fill="none"/>
          </g>
        </g>
      </svg>
      Filters</button>`;

    return html;
  };

  Utils.convertPriceBasedOnPresentmentPrice = function(productData) {
  	var currenciesSeting = Settings.getSettingValue('general.currencies');

  	if (typeof currenciesSeting != 'undefined' && currenciesSeting.length > 1) {
  		var currentCurrency = Settings.getSettingValue('general.current_currency').toLowerCase().trim();
  		var prices = ['price_min', 'price_max', 'compare_at_price_min', 'compare_at_price_max'];
  		prices.forEach((priceKey) => {
  			var currentPriceKey = priceKey + '_' + currentCurrency;
  			if (typeof productData[currentPriceKey] != 'undefined') {
  				productData[priceKey] = productData[currentPriceKey];
  			}
  		});
        productData.variants.forEach((variant) => {
          var currentPriceKey = 'price_' + currentCurrency;
          var currentComparePriceKey = 'compare_at_price_' + currentCurrency;
          if (typeof variant[currentPriceKey] != 'undefined') {
              variant.price = variant[currentPriceKey];
          }
          if (typeof variant[currentComparePriceKey] != 'undefined') {
              variant.compare_at_price = variant[currentComparePriceKey];
          }
        })
  	}
  }

  $('body').on('click', '[data-filter-toggle-mobile] button', () => {
    const drawer = document.querySelector('[data-mobile-filter-drawer]')
    if (drawer) {
      const focusableElements = drawer.querySelectorAll('button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"]')
      const overlay = drawer.querySelector('.boost-pfs-filter-overlay')

      if (overlay) {
        overlay.setAttribute('role', 'button')
        overlay.setAttribute('tabindex', 0)
        overlay.focus()
      }

      focusableElements.forEach((element) => {
        element.setAttribute('tabindex', 0)
        element.setAttribute('aria-hidden', 'false')
      })
    }
  })

  $('body').on('click', '[data-mobile-filter-drawer] .boost-pfs-filter-close, [data-mobile-filter-drawer] .boost-pfs-filter-show-result', () => {
    const drawer = document.querySelector('[data-mobile-filter-drawer]')
    const focusableElements = drawer.querySelectorAll('button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"]')
    const overlay = drawer.querySelector('.boost-pfs-filter-overlay')

    if (overlay) {
      overlay.removeAttribute('role', 'button')
      overlay.removeAttribute('tabindex', 0)
    }

    focusableElements.forEach((element) => {
      element.setAttribute('tabindex', -1)
      element.setAttribute('aria-hidden', 'true')
    })
  })

  document.addEventListener('keyup', (e) => {
    if (e.key === 'Escape' && document.querySelector('.boost-pfs-body-no-scroll')) {
      const drawer = document.querySelector('[data-mobile-filter-drawer]')
      const close = drawer.querySelector('.boost-pfs-filter-close')
      close.dispatchEvent(new Event('click', { bubbles: true }))
    }
  })

  /* Boost - 229068 */
  FilterApi.beforeCall = function(eventType, eventInfo) {
    /* Change the filter params before calling api */
    var hiddenOptions = ["not-pre-order"];
    if (boostPFSAppConfig.general.collection_handle != 'pre-order') {
      Globals.queryParams.h_options = hiddenOptions;
    }
    Globals.queryParams.currency = boostPFSConfig.general.current_currency.toLowerCase();
    Globals.queryParams.currency_rate = Shopify.currency.rate;
    Globals.queryParams.return_all_currency_fields = false;
    /* No need to return anything */
  }
  /* Boost - 229068 */

  /* Add To Bag PLP */

  const buttonAdToBag = () => {
    const buttons = document.querySelectorAll('.product-tile__addToBag-button-add');

    buttons.forEach(item => {
      item.removeEventListener("click", handleAddToBagClick);
      item.addEventListener("click", handleAddToBagClick);
    });
  }


  const handleAddToBagClick = (event) => {
    jQ('.product-tile__addToBag-container:not(.product-tile__addToBag-container--alt-view)').removeClass('showSized');
    const item = event.currentTarget;
    const fatherButton = item.closest('.product-tile__addToBag-container');
    fatherButton.classList.toggle('showSized');
  }


  const buttonSizes = () => {
    const buttons = document.querySelectorAll('[data-variantaddtobag]');

    buttons.forEach(item => {
      item.removeEventListener('click', handleSizeClick);
      item.addEventListener('click', handleSizeClick);
    });
  }


  const handleSizeClick = (event) => {
    const item = event.currentTarget;
    const fatherButton = item.closest('.product-tile__addToBag-container');
    fatherButton.classList.toggle('showSized');
  }

  const addToBagFunctionality = () => {
    const buttons = document.querySelectorAll('[data-variantAddToBag]');

    buttons.forEach(button => {
      button.removeEventListener("click", handleVariantAddToBagClick);
      button.addEventListener("click", handleVariantAddToBagClick);
    });
  }

  const handleVariantAddToBagClick = (event) => {
    const button = event.currentTarget;
    const variantId = button.getAttribute('data-variantAddToBag');

    VueMinicart.addItem({
      id: variantId,
      quantity: 1
    });
  }


  const observeCollectionChanges = () => {
    let collectionsPageAddToBag = document.querySelector('.collection__products');

    if (collectionsPageAddToBag) {
      const observer = new MutationObserver(() => {

        buttonAdToBag();
        buttonSizes();
        addToBagFunctionality();

      });

      observer.observe(collectionsPageAddToBag, {
        childList: true,
        subtree: true
      });
    }
  }

  buttonAdToBag();
  buttonSizes();
  addToBagFunctionality();

  observeCollectionChanges();


  /* End Add To Bag PLP */

  /* Aligned Items on PLP */

  const alignedElements = (selector) => {

    let mediaProduct = document.querySelectorAll(selector)

    mediaProduct.forEach(function (element) {

      let nextElement = element.nextElementSibling;
      let isSmallScreen = window.matchMedia('(max-width: 450px)').matches;

      if (!nextElement.classList.contains('product-tile__options')) {

        if (isSmallScreen) {
          element.style.marginBottom = '36px';
        }else{
          element.style.marginBottom = '40px';
        }

      }

    });

  }

  window.addEventListener('load', () => {

    const intervalo = setInterval(() => {
      alignedElements('.product-tile__media')
    }, 1000);

    setTimeout(() => {
      clearInterval(intervalo);
    }, 3000);


    let navPagination = document.querySelector('.collection__pagination')

    navPagination.addEventListener('click', () => {
      setTimeout(() => {
        alignedElements('.product-tile__media')
      }, 3000)
    })

  })

  /* Aligned Items on PLP */
    const interval = setInterval(() => {
        const firstFilterColor = document.querySelector('.boost-pfs-filter-option-swatch-image');

        if (firstFilterColor) {
            clearInterval(interval);
            // VIX-529 Temporarily disabled as this is throwing errors in console sometimes
            // aplicarABTest();
        }
    }, 1000);

})();
